import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/BackButton/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/legal/AvisoLegalContent.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Scroll/index.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/politica-de-privacidad/style.css");
